const ADMIN_ATTENTION_TYPES = new Set([
  "membership_expiring",
  "medical_expiring",
  "medical_expired",
  "debt",
  "debtors",
  "unpaid_membership",
  "pending_registration",
  "competition_application",
  "poll_pending",
  "subscription_expiring",
  "session_unfinished",
]);

export function formatNotificationText(item) {
  if (!item) return "";
  if (item.type === "chat_message") {
    const url = String(item.url || "");
    if (url.includes("/app/chat/personal")) {
      return "У вас новое сообщение";
    }
    if (url.includes("/app/chat/group/")) {
      return "Новое сообщение в чате группы";
    }
    if (url.includes("/app/chat")) {
      return "У вас новое сообщение";
    }
    const rawTitle = String(item.title || "").trim();
    const name = rawTitle
      .replace(/^Сообщение:\s*/i, "")
      .replace(/^Чат$/i, "")
      .trim();
    if (name && name !== "Сообщение от клиента" && name !== "Сообщение от клуба") {
      return `Новое сообщение от ${name}`;
    }
    return "Новое сообщение от клиента";
  }

  const text = String(item.text || item.body || "").trim();
  if (text.length <= 96) return text;
  return `${text.slice(0, 93)}…`;
}

export function formatNotificationLabel(item) {
  if (!item) return "Уведомление";
  if (item.type === "chat_message") return "Чат";
  return item.title || item.action_label || "Уведомление";
}

export function filterDashboardNotifications(notifications) {
  return (notifications || []).filter((n) => {
    if (n.type === "revenue" || n.type === "absent_long") return false;
    if (ADMIN_ATTENTION_TYPES.has(n.type)) return true;
    if (n.type === "membership_expiring" || n.type === "medical_expiring") {
      return n.tone === "warn" || n.tone === "danger";
    }
    return false;
  });
}

export function mergeAdminNotificationFeed(pushFeed, dashboardFeed) {
  const map = new Map();
  for (const item of [...pushFeed, ...dashboardFeed]) {
    const key = item.id || `${item.type}:${item.text}`;
    if (!map.has(key)) map.set(key, item);
  }
  return [...map.values()].sort((a, b) => {
    const ta = new Date(a.sent_at || 0).getTime();
    const tb = new Date(b.sent_at || 0).getTime();
    return tb - ta;
  });
}

export function normalizeAdminNotification(item) {
  return {
    ...item,
    title: formatNotificationLabel(item),
    text: formatNotificationText(item),
    url: item.url || item.action_path || item.href || null,
    is_read: Boolean(item.is_read ?? item.read_at),
  };
}
